export default "__VITE_PUBLIC_ASSET__361c86b2__"